<p-popover #combinedEligibilityPopover [dismissable]="false" appendTo="body" [autoZIndex]="true" [baseZIndex]="10000">
  <div class="p-2" style="max-width: 320px">
    <p class="mb-2 fw-500">The selected model/elevation violates the following rule(s):</p>
    <ul class="mb-2 ps-3">
      @for (rule of combinedEligibilityRulesMessage(); track rule) {
        <li>{{ rule }}</li>
      }
    </ul>
  </div>
</p-popover>
<div class="row gy-3">
  <div class="col-xl-12">
    <div class="card rounded-4 h-100">
      <div class="card-body">
        <div class="align-items-center bg-light d-flex mb-3 p-3 rounded-3 gap-2">
          <i class="bi bi-bounding-box"></i>
          <h3 class="mb-0">Lot Details</h3>
          <span class="badge bg-spec text-uppercase">{{ specLot()?.lotTypeName ?? '-' }}</span>
          <button type="button" class="btn btn-outline-primary btn-sm ms-auto" (click)="openEditLotModal()">
            <i class="bi bi-pencil me-1"></i>Edit
          </button>
        </div>
        <div class="row gy-3 m-0">
          @if (specLot()) {
            <div class="col-xl1-4 col-md-6 col-12">
              <label class="fw-500 d-block">Unit No.</label>
              <span class="text-muted">{{ specLot()!.lotNo }}</span>
            </div>

            <div class="col-xl1-4 col-md-6 col-12">
              <label class="fw-500 d-block">Project</label>
              <span class="text-mutted">{{ specLot()!.projectCode }}</span>
            </div>
            <div class="col-xl1-4 col-md-6 col-12">
              <label class="fw-500 d-block">Status</label>
              <span class="text-muted">{{ specLot()!.statusName || '-' }}</span>
            </div>
            <div class="col-xl1-4 col-md-6 col-12">
              <label class="fw-500 d-block">City</label>
              <span class="text-muted">
                @if (specLot()!.address && specLot()!.address.cityName) {
                  {{ specLot()!.address.cityName }}
                } @else {
                  -
                }
              </span>
            </div>
            <div class="col-xl1-4 col-md-6 col-12">
              <label class="fw-500 d-block">Premium Amount</label>
              <span class="text-muted">
                @if (specLot()!.lotPremiumAmount) {
                  {{ formatCurrency(specLot()!.lotPremiumAmount) }}
                }
              </span>
            </div>
            <!-- <div class="col-xl1-4 col-md-6 col-12">
              <label class="fw-500 d-block">Unit Price</label>
              <span class="text-muted">
                @if (specLot()!.lotUnitPrice) {
                  {{ formatCurrency(specLot()!.lotUnitPrice) }}
                }
              </span>
            </div> -->

            <div class="col-xl1-4 col-md-6 col-12">
              <label class="fw-500 d-block">Model</label>
              <span class="text-muted">
                @if (specLot()!.selectedModel; as selectedModel) {
                  {{ selectedModel.modelName }}
                }
                <!-- @else if (specLot()!.models && specLot()!.models.length > 0) {
                  {{ specLot()!.models[0].modelName }}
                } -->
                @else {
                  -
                }
              </span>
            </div>
            <div class="col-xl1-4 col-md-6 col-12">
              <label class="fw-500 d-block">Elevation</label>
              <span class="text-muted">
                @if (specLot()!.selectedElevation; as selectedElevation) {
                  {{ selectedElevation.elevationCode }}
                  @if (selectedElevation.description) {
                    - {{ selectedElevation.description }}
                  }
                } @else {
                  -
                }
              </span>
            </div>
            <div class="col-xl1-4 col-md-6 col-12">
              <label class="fw-500 d-block">Swing</label>
              <span class="text-muted">{{ specLot()!.swing || '-' }}</span>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="col-xl-12">
    <div
      class="card mb-4 border rounded-4 h-100"
      [ngClass]="{
        'border-warning':
          !isLotTypeReg() &&
          eligibilityResult() &&
          !eligibilityResult()!.isEligible &&
          combinedEligibilityRulesMessage().length > 0
      }"
    >
      <div class="card-body">
        <div class="align-items-center bg-light d-flex mb-3 p-3 rounded-3 gap-2">
          <i class="bi bi-grid-3x3"></i>
          <h3 class="mb-0">Lot Setup</h3>
        </div>
        @if (
          !isLotTypeReg() &&
          eligibilityResult() &&
          !eligibilityResult()!.isEligible &&
          combinedEligibilityRulesMessage().length > 0
        ) {
          <p-message
            severity="warn"
            icon="pi pi-exclamation-triangle"
            text="Violations: {{ combinedEligibilityRulesMessage().length + ' Rule(s) Violated' }}"
            styleClass="mb-3"
            (mouseenter)="showCombinedEligibilityRules($event)"
            (mouseleave)="hideCombinedEligibilityRules()"
          />
        }
        <form [formGroup]="modelElevationForm">
          <div class="row gy-3">
            <div class="col-xl1-4 col-md-6 col-12">
              <generic-dropdown
                [items]="readLotTypes()"
                [label]="'Lot Type'"
                [placeholder]="'Select Lot Type'"
                [required]="true"
                [allowSearch]="true"
                [clearable]="true"
                formControlName="lotTypeId"
              >
              </generic-dropdown>
            </div>
            <div class="col-xl1-4 col-md-6 col-12">
              <generic-dropdown
                [items]="modelsDropdownData()"
                [label]="'Model'"
                [placeholder]="'Select Model'"
                [required]="!isLotTypeReg()"
                [disabled]="isLotTypeReg()"
                [allowSearch]="true"
                formControlName="modelId"
              >
              </generic-dropdown>
            </div>
            <div class="col-xl1-4 col-md-6 col-12">
              <generic-dropdown
                [items]="elevationsDropdownData()"
                [label]="'Elevation'"
                [placeholder]="'Select Elevation'"
                [required]="!isLotTypeReg()"
                [disabled]="isLotTypeReg()"
                [allowSearch]="true"
                formControlName="elevationId"
              >
              </generic-dropdown>
            </div>
            <!-- @if (
              isLotTypeNotReg() &&
              eligibilityResult() &&
              !eligibilityResult()!.isEligible &&
              combinedEligibilityRulesMessage().length > 0
            ) {
              <div class="col-xl1-4 col-md-6 col-12">
                <label class="fw-500 d-block">Violations</label>
                <div class="align-items-center badge bg-danger-subtle d-inline-flex justify-content-center text-danger">
                  <i
                    class="bi bi-info-circle text-danger fs-16 me-2 cursor-pointer"
                    (mouseenter)="showCombinedEligibilityRules($event)"
                    (mouseleave)="hideCombinedEligibilityRules()"
                  ></i>
                  <span class="fw-500">{{ combinedEligibilityRulesMessage().length + ' Rule(s) Violated' }}</span>
                </div>
              </div>
            } -->
            <div class="col-12 align-self-end">
              <div class="d-flex align-items-center justify-content-end gap-2">
                <button type="button" class="btn btn-outline-primary btn-h42" (click)="resetPage()">Reset</button>
                <button
                  type="button"
                  class="btn btn-primary btn-h42"
                  [disabled]="modelElevationForm.invalid"
                  (click)="saveChanges()"
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<p-confirmdialog>
  <ng-template #message let-message>
    <div>
      <p>The selected Model/Elevation violates the following rule(s):</p>
      <ul>
        @for (rule of violationRules; track rule) {
          <li>{{ rule }}</li>
        }
      </ul>
    </div>
  </ng-template>
</p-confirmdialog>
